export default {
  formFields: {
    fieldHelp: 'Clique para abir o descrição do campo',
    defaultAbbreviation: 'padr.: ',
    paramJSONContent: 'conteúdo JSON',
    wrongInputValue: 'Valor de entrada errado para este parâmetro.',
    notValidJsonString: 'JSON não válido para :fieldName',
  }
}
